// extracted by mini-css-extract-plugin
export default {"direction-header":"Lh8P3O+1rZ","directionHeader":"Lh8P3O+1rZ","policy-source":"i5+t3zUOcv","policySource":"i5+t3zUOcv"};
    if(module.hot) {
      // 1643570517549
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  